import CircularProgress from '@/global/components/CircularProgress'
import Dialog from 'global/guides/Dialog'
import { useAuth } from 'hooks'
import { CircleCheckBig, XCircle } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { avaliacao } from 'service/api'
import { toast } from 'sonner'

type Status = 'loading' | 'success' | 'error'

export default function ConfirmarEmail() {
    const navigate = useNavigate()
    const { handleLogin } = useAuth()
    const [searchParams] = useSearchParams()
    const hash = searchParams.get('hash')

    const [status, setStatus] = useState<Status>('loading')
    const [errorMessage, setErrorMessage] = useState<string>('')

    useEffect(() => {
        if (!hash) {
            setStatus('error')
            setErrorMessage('Link de confirmação inválido')
            return
        }

        avaliacao
            .confirmarEmail(hash)
            .then(data => {
                setStatus('success')
                toast.success('Email confirmado com sucesso!')

                if (data.Token) {
                    setTimeout(() => {
                        handleLogin(data.Token!)
                    }, 2000)
                }
            })
            .catch(error => {
                setStatus('error')
                setErrorMessage(
                    error?.message ||
                        'Erro ao confirmar email. O link pode estar expirado.',
                )
            })
    }, [hash])

    if (status === 'loading') {
        return (
            <Dialog.Root width="30rem" height="auto">
                <Dialog.Title>Confirmando email</Dialog.Title>
                <Dialog.Content dividers>
                    <div className="flex flex-col items-center gap-6 py-8">
                        <CircularProgress className="size-16!" />
                        <p>Aguarde, estamos confirmando seu email...</p>
                    </div>
                </Dialog.Content>
            </Dialog.Root>
        )
    }

    if (status === 'error') {
        return (
            <Dialog.Root width="30rem" height="auto">
                <Dialog.Title>Erro na confirmação</Dialog.Title>
                <Dialog.Content dividers>
                    <div className="flex flex-col items-center gap-6 py-4">
                        <XCircle className="text-error size-24" />
                        <div className="text-center space-y-2">
                            <p className="text-lg font-semibold text-error">
                                Não foi possível confirmar seu email
                            </p>
                            <p>{errorMessage}</p>
                            <p className="text-sm mt-4">
                                Se o problema persistir, entre em contato com o
                                suporte.
                            </p>
                        </div>
                    </div>
                </Dialog.Content>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton
                        onClick={() => navigate('/avaliacao')}
                    >
                        Cadastrar novamente
                    </Dialog.Actions.SecondaryButton>
                    <Dialog.Actions.SecondaryButton
                        onClick={() =>
                            window.open(
                                'https://atendimento.farolsoftware.com.br/',
                                '_blank',
                            )
                        }
                    >
                        Suporte
                    </Dialog.Actions.SecondaryButton>
                    <Dialog.Actions.PrimaryButton onClick={() => navigate('/')}>
                        Voltar ao login
                    </Dialog.Actions.PrimaryButton>
                </Dialog.Actions>
            </Dialog.Root>
        )
    }

    return (
        <Dialog.Root width="30rem" height="auto">
            <Dialog.Title>Email confirmado!</Dialog.Title>
            <Dialog.Content dividers>
                <div className="flex flex-col items-center gap-6 py-4">
                    <CircleCheckBig className="text-green-500 size-24" />
                    <div className="text-center space-y-2">
                        <p className="text-lg font-semibold">
                            Sua conta foi ativada com sucesso!
                        </p>
                        <p className="text-gray-600">
                            Seu período de teste grátis de 14 dias começou.
                        </p>
                        <p className="text-sm text-gray-500 mt-4">
                            Você será redirecionado automaticamente...
                        </p>
                    </div>
                </div>
            </Dialog.Content>
        </Dialog.Root>
    )
}
